import { IBaseService } from '@/bundles/App/interfaces';
import AdCampaignToMapper from '@/bundles/Ad/mappers/AdCampaignToMapper';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import { PaginationResponse } from '@/bundles/App/type';
import { IAdCampaign } from '@/bundles/Ad/interfaces';
import { CreateAdCampaignDto, EditAdCampaignDto, IChangeCampaignStatusDto, IGetCampaignDto } from '@/bundles/Ad/dto';

export default class AdCampaignService implements IBaseService<AdCampaignToMapper> {
  errorMapper: ErrorMapper;
  recordMapper: AdCampaignToMapper;
  transport: HttpTransport;

  constructor (props: IBaseService<AdCampaignToMapper>) {
    this.errorMapper = props.errorMapper;
    this.recordMapper = props.recordMapper!;
    this.transport = props.transport;
  }

  async getList (params: IGetCampaignDto): Promise<PaginationResponse<IAdCampaign>> {
    try {
      const response = await this.transport.get('/ad-campaign', params);
      return {
        data: response.data.map((item: IAdCampaign) => this.recordMapper.mapToModel(item)),
        total: response.total,
      };
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async changeStatus (id: number, payload: IChangeCampaignStatusDto) {
    try {
      await this.transport.patch(`/ad-campaign/${id}/change-status`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async editCampaign (id: number, payload: EditAdCampaignDto) {
    try {
      await this.transport.put(`/ad-campaign/${id}`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async getCampaign (id: number) {
    try {
      const response = await this.transport.get(`/ad-campaign/${id}`);
      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async createCampaign (payload: CreateAdCampaignDto) {
    try {
      await this.transport.post('/ad-campaign', payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
